import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(full-width)/filament-material-guide/MaterialsTable/index.tsx");
